// The offer a customer tapped "use at checkout" on — held per store for the
// session, applied by the checkout the next time it opens, and dropped once
// an order is placed or the customer removes it. The server still judges
// the code on every quote; this only saves the typing.

const key = (storeKey: string) => `rp-order-coupon:${storeKey}`;

export function pendingCoupon(storeKey: string): string | null {
  try {
    return sessionStorage.getItem(key(storeKey));
  } catch {
    return null;
  }
}

export function holdCoupon(storeKey: string, code: string): void {
  try {
    sessionStorage.setItem(key(storeKey), code);
  } catch {
    /* storage off — the customer types the code instead */
  }
}

export function dropCoupon(storeKey: string): void {
  try {
    sessionStorage.removeItem(key(storeKey));
  } catch {
    /* nothing held */
  }
}
